import { useEffect, useState } from 'react';

const defaultDefaultImage = "https://bulma.io/images/placeholders/1280x960.png";

const Image = ({ alt, src, defaultImage, ...props }) => {
  const [overiddenSrc, setOveriddenSrc] = useState(null);
  const overiddenDefaultImage = defaultImage || defaultDefaultImage;

  useEffect(() => {
    setOveriddenSrc(null);
  }, [src]);

  return (
    <img
      {...props}
      alt={alt}
      src={overiddenSrc || src}
      onError={() => setOveriddenSrc(overiddenDefaultImage)} />
  )
}

export default Image;
